// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> the-residences-at-st-joseph-s-court
// Generated: 2026-10-22T20:04:36.798Z
// Counts: 1 design, 67 content, 61 slot group, 1 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 & 2 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>55+ Active Community in Levittown , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>The Residences at St. Joseph's Court</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Residences at St. Joseph's Court, a 55+ community, find your haven in Levittown, PA, with spacious one and two-bedroom floor plans. Immerse yourself in vibrant local life, with nearby parks and the Fairless Hills YMCA. Enjoy the perfect blend of comfort and convenience at your new community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>55+ Active Apartment Community in Levittown</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The friendly vibe at The Residences at St. Joseph Court is enhanced by amenities designed to make your life easier and more enjoyable. Step from the luxe comfort of your home to the beautifully landscaped grounds, catch up with neighbors at the various social spaces, or meet other pet lovers at the nearby parks. This is the spot to be in Levittown, Pennsylvania.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>See <span data-type=\"field-token\" data-field=\"property_name\"></span> in person</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Residences at St. Joseph's Court 55+, where modern comfort meets community spirit in Levittown, PA. Choose from spacious one or two-bedroom floor plans, complete with granite countertops, stainless steel appliances, and ample storage. Enjoy amenities like a fitness center, clubhouse, and planned activities—all designed for your lifestyle. Find your new home and lease online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Residences at St. Joseph's Court 55+ in Levittown, PA, choose from thoughtfully designed one and two-bedroom floor plans tailored for comfort and convenience. Ready to learn more? Our leasing team is here to assist you! Connect with us today to uncover your perfect home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 55+ active adult apartments for rent in Levittown, PA, have all the life-enhancing conveniences you need. Whip up a feast in your gourmet kitchen and enjoy all the modern perks throughout every room. Enjoy community extras like a fitness center with strength training equipment and a resident clubhouse. The Residences at St. Joseph Court makes it easy to get comfortable in your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look and imagine enjoying your private retreat and welcoming <a href=\"https://www.theresidencesatstjosephcourt.com/floor-plans/\">55+ active adult apartment community in Levittown, Pennsylvania</a>. The affordable one and two bedroom apartments at The Residences at St. Joseph Court deliver on everything you need and more. Bring your pet, your roomy, or just yourself, and then settle in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Residences at St. Joseph Court has a pleasant location in Bucks County, conveniently close to outdoor recreation, and excellent shopping centers. When you get home, you can spread out in your spacious <a href=\"https://www.theresidencesatstjosephcourt.com/floor-plans/\">one- or two-bedroom 55+ active adult apartment for rent in Levittown, PA,</a> or head out to one of the local eateries nearby. Living at The Residences at St. Joseph Court truly makes your work/life balance a snap.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Senior Living in Levittown , PA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We love pets and happily welcome dogs, cats, and service animals to our community. Breed restrictions apply; please contact the leasing office for details. A one‑time, non‑refundable pet fee of $300 is due at move‑in (or $350 for 2 pets), and monthly pet rent is $50 per pet (or $75/month for 2 pets.) We allow up to 2 pets per home, and there are no weight restrictions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our collection of spacious one- and two-bedroom floor plans and find your perfect landing place in Levittown at The Residences at St. Joseph Court. Our pet-friendly, <a href=\"https://www.theresidencesatstjosephcourt.com/floor-plans/\">55+ active apartment community in Levittown</a> provides a comfortable retreat with an array of upgrades, plus friendly neighborhood vibes that will leave you wondering how you ever lived without them! Here, you can stay in shape at the fitness center, stay focused on work or hobbies at the business center, or relax in style at the resident lounge.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Residences at St. Joseph's Court 55+, where comfortable living meets vibrant community life in Levittown, PA. Enjoy a variety of thoughtfully designed floor plans, including one-bedroom and two-bedroom options. Log in to your resident portal to easily pay rent, schedule maintenance, and enjoy seamless living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for your interest in The Residences at St. Joseph's Court 55+ in Levittown, PA! Our thoughtfully designed one and two-bedroom floor plans offer comfort and community. A team member will reach out soon to assist you in finding your perfect home among our charming options.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Residences at St. Joseph's Court 55+, located in vibrant Levittown, PA, you'll find thoughtfully designed <a href=\"https://www.theresidencesatstjosephcourt.com/floor-plans/\">one- and two-bedroom apartments.</a> Immerse yourself in our community's charm by taking a virtual tour today—where comfort meets convenience in a thriving neighborhood for those aged 55 and better!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-58d9-7498-ac01-6154478102e8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright empty living room with white walls, wood-look flooring, and a sliding glass door to a balcony at The Residences at St. Joseph's Court in Levittown, PA."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-646c-71b1-9829-9ad9b3276c7e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with treadmills, elliptical, and stationary bike."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-a1ed-765c-8b39-3cb097d710f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright resident lounge with round tables, leather chairs, a bookshelf, and large windows."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026c-ae04-777b-a744-50c04b4a7a5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community fitness center with treadmills, stationary bikes, ellipticals, and free weights."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166355/019d026e-a1ed-765c-8b39-3cb097d710f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resident game room with poker tables, chairs, and a bookshelf."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-7e28-726f-a343-f7174075f28f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright apartment bedroom with a large window, white walls, and light wood-look flooring."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-802a-77fc-995e-4865771b5710.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright apartment living room with wood-look flooring and a sliding glass door to a balcony."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-911b-7108-b5ea-7af05fbaab46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment kitchen with white cabinets, stainless steel appliances, and a large island with bar stools."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-704c-74fb-9359-2d9f58cdc262.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a multi-building apartment complex with a parking lot in front at The Residences at St. Joseph's Court in Levittown, PA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026d-3526-7787-880a-9efe87abeb06.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Neshaminy State Park riverfront with walking paths and green space near Levittown."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026d-34d7-729d-b6db-3a82412fb4a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Falls Township Community Park green space with open lawns and recreation areas."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026d-0e7c-75f6-9d38-a8d4ec38b53b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Levittown Town Center shopping area with local stores and shops."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-6f63-766b-a86f-bb6a0ae52d7f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered patio with wicker furniture and ceiling fans overlooking a lawn."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026c-b7d5-72ad-8bc4-ce4a2229aef3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of the apartment community with brick and siding buildings and manicured landscaping."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-9fa0-774f-91b4-cfcb44a3009e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Landscaped grounds and buildings of the apartment community with a spacious parking lot."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166355/019d026c-b7d5-72ad-8bc4-ce4a2229aef3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of the multi-building apartment community and its surrounding grounds."
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$300"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent — 2nd Pet"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.storage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Storage"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75 large / $55 small"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "$5–$8"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50–$60"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce70-85d7-735c-97ac-b6fd4c2e3c21.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View All"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-8eb1-71ae-8ed0-e4f04f9ea21a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept living and dining area with a beige sofa, dark wood dining table, and potted plants"
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce70-8c83-702c-90a9-4dec0c7031cd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "One Bedroom"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce70-8d0b-708c-960e-9f7fbf054c29.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two Bedroom"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019d026e-802a-77fc-995e-4865771b5710.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright empty living room with white walls, wood-look flooring, and a sliding glass door to a balcony."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-91a6-75a9-8324-7acf4409bd27.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Bridge Coffee & Community"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & Cafe"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.8"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Laid-back coffee shop featuring vegetarian and vegan options, plus a share of its profits goes to the community."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce0f-ff76-76e9-a941-36a3c3f13578.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Oxford Valley Mall"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.9"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "2-story mall since 1973, with department stores, a food court, kids' play area & nursing lounge."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fce10-3f6f-726c-bc23-912714dcd44e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Core Creek Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Green Space"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Community area providing sports fields & courts, a playground, boating, fishing, lawns & a dog park."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-9183-771d-8c46-2b8359b898b4.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Golden Dawn"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.6"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Mellow-old school diner providing a long menu of traditional American & Italian eats till late."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-eb29-7387-8426-ce8e29b08518.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Pennsbury Manor"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.4"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Reconstructed site features a riverside manor where visitors can experience 17th-century life."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-fe3a-706b-a322-209fa2424fcf.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Neshaminy State Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "7.2"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "This 334-acre riverfront park offers fishing, walking paths, 2 seasonal pools & picnic pavilions."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-9c6c-72c9-968c-fd4e7966ba0e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Gleasons Bar"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Nightlife"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.8"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Informal bar offering cheesesteaks, wings, and other bites, plus live entertainment."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-e84c-75c4-9fc4-824027673d6a.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Langhorne Brewing Company"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brewery & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Local craft brewery pouring house-made beers in a laid-back taproom with live entertainment."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-9a39-779b-8cec-51337072c207.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Salvatore’s Cucina"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dinner & Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual, comfortable eatery specializing in Italian meals such as veal and buffalo chicken, plus pizza."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-de01-730b-8a5a-6a1561be6d2a.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Parx Casino"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Lounge & Late-Night"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "9.1"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "\"Racino\" offers live horse racing, slots, table games & poker, with a variety of restaurants & bars."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-e159-75f8-890e-b8b221227fe6.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "AMC Neshaminy 24"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Theater"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.0"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Chain multiplex featuring IMAX and Dolby sound systems, plus spacious seating and reclining chairs."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166355/019fd811-ca0c-736d-84a2-8a13b7acc7fd.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Mauricio’s Pizza & Grill"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.6"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Pizza, cheesesteaks, hoagies, and more offered by a casual joint with late-night hours and delivery."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 10,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_56f090c9-f2a7-4f2e-912b-8450c8539459",
      "custom_6ffc26a4-c493-49e9-bd7c-8948e384d283",
      "custom_c86cc7ba-28bb-45b5-83f2-622fdc698eee",
      "custom_bd905d35-4de6-4714-a83d-ef24f2d49133",
      "custom_0456b4a7-e21e-4e1f-8276-d7f4bd9e1c10",
      "custom_77f6f65e-a331-4aa0-aecf-8711e6169167",
      "custom_176e8102-a7f7-44fd-b52d-913aaf8be18d",
      "custom_afb0f906-4766-4519-b946-6f4f56108c71",
      "custom_a1ca6bf8-2828-4df2-9b63-4ad182c4132e"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
